"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.InstantSearchCard = function (props) {
    return (React.createElement("a", { href: "/products/" + props.product.handle, title: props.product.title, className: "flex items-start justify-start w-full transition-all py-1-2 px-2-4" },
        React.createElement("div", { className: "border border-secondary-blue-grey w-10 h-10 min-w-10 rounded bg-center bg-no-repeat bg-contain", style: {
                backgroundImage: "url('" + props.product.image.replace(".jpg", "_x200.jpg").replace(".png", "_200x.png") + "')"
            } }),
        React.createElement("div", { className: "w-full font-sans text-left text-midnight text-15 pl-2-5" },
            React.createElement("p", { className: "font-semibold pb-0-8 lg:pb-1-6" }, props.product.title),
            React.createElement("p", { className: "lg:font-semibold" },
                "$",
                props.product.price_min))));
};
